import { render, staticRenderFns } from "./dataSummaryScreen copy.vue?vue&type=template&id=7722d5ea&scoped=true&"
import script from "./dataSummaryScreen copy.vue?vue&type=script&lang=js&"
export * from "./dataSummaryScreen copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7722d5ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7722d5ea')) {
      api.createRecord('7722d5ea', component.options)
    } else {
      api.reload('7722d5ea', component.options)
    }
    module.hot.accept("./dataSummaryScreen copy.vue?vue&type=template&id=7722d5ea&scoped=true&", function () {
      api.rerender('7722d5ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/dataSummaryScreen copy.vue"
export default component.exports